<template>
  <!--<div class="wrap">
    <div class="title"></div>-->
    <div class="echarts-wrap" ref="chart"></div>
  <!--</div>-->
</template>

<script>
  import {echartsMixin} from 'assets/js/common/mixin'
  import {dataZoom} from 'assets/js/common/echartsComm.js'
  export default {
    name: "worth",
    mixins: [echartsMixin,dataZoom],
    data() {
      return {
        echartsData: {
        	yield:[22, 26, 25, 28, 20, 26, 22, 24, 23, 26, 21,22],
        }
      }
    },
    watch: {
      echartsData: {
        handler: function (val, oldVal) {
          this.initChart();
        },
        deep: true  //增加deep 观察对象的子对象变化
      }
    },
    mounted(){
      this.$nextTick(() => {
        this.myChart = this.$echarts.init(this.$refs.chart);
        this.initChart()
      })
    },
    methods:{
      initChart(){
        let datas = {
          datax:[],
          datas:[]
        }
        let option = {
          calculable : true,
          tooltip: {
            trigger: 'axis',
            formatter:(params)=>{
							let html = "<div style='padding:15px'><p style='text-align:center;font-Weight:bold'>"+params[0].name+"：</p>"     
								html+=`<span style="color:#FF8A22;font-weight:bold;text-algin:center">${params[0].data}(kg)</span><br/>`
							return html+'</div>' 
						},
            backgroundColor:"#002624",
						borderColor:'#009288',
						borderWidth:1,
            textStyle:{
							color:"#fff",
						},
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'line',        // 默认为直线，可选为：'line' | 'shadow'
              lineStyle:{
                color: '#FFBD2E',
                width:2,
                type:"dashed"
              }
            },
          },
          grid: {
            left: '20',
            right: '51',
            bottom: '30',
            top: "40",
            containLabel: true
          },
          dataZoom,
          xAxis: {
            name:'',
            nameTextStyle:{
              color:'#fff'
            },

            type: 'category',
            boundaryGap: false,//折线距离y轴有无距离
            axisLabel: {
              fontSize: 12,
              color: "#fff",
              margin: 5
            },
            axisTick: {
              show:false
            },

            axisLine: {
              lineStyle: {
                color: "#35ece6",
                type: "solid",
                width: 1
              }
            },
            data : ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
          },
          yAxis: {
            name:'单位（kg）  ',
            nameTextStyle:{
              color:'#99FFCC',
              fontWeight: 'bold',
              padding: [0, 0, 0, 20],
            },
            type: 'value',
            //min: 0,
            //max: 100,
            //interval: 20,
            axisLabel: {
              margin: 10,
                fontSize: 12,
                color: "#fff",
              formatter:'{value}',
            },
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: "#35ece6",
                type: "solid",
                opacity:1
              }
            },
            splitLine: {
              lineStyle: {
                color: '#015255', //分割线颜色
                type: "dashed",
                width:1
              }
            }
          },
          lineStyle:{
            normal:{
              color:'#0654b8'
            }
          },
          itemStyle:{
            normal:{
              color:'#00a6ff',
              borderWidth:'2'
            }
          },

          series : [
            {
              name:'土地价值评估指数',
              type:'line',
              smooth:false,
              markLine:{
              symbolSize: 0,
              lineStyle: {
                normal: {
                  color: '#FF5400',
                  type: 'solid',
                  width: 1
                }
              },
              data: [{
//              type: 'min',
                name:"平均值",
                yAxis: 5
                }]
            },
              lineStyle:{
              	color:"#009ED7",
              },
              itemStyle: {
              	normal: {
              		color:"pink",
              		borderColor:"#009ED7",
              		borderWidth:2,
               },
               emphasis:{
               	  borderColor:"#009ED7",
              		borderWidth:2,
//             	  color:"#081211"
               }
              },
              data:this.echartsData.yield,
              symbolSize: 8,
              areaStyle:{
                normal:{
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0.7,
                    color: 'rgba(0,255,203,0.83)'
                  }, {
                    offset: 1,
                    color: 'rgba(0,209,255,0.83)'
                  }]),
                  opacity:0.2

                }
              }
            },
          ]
        };
        this.myChart.setOption(option);
      },
      // echats 图表自适应
      _resizeHanlder() {
        this.myChart.resize()
      },
      // 销毁echats图表方法
      _destroyHandler() {
        if (this.myChart) {
          this.myChart.dispose()
        }
      }
    }
  }
</script>

<style scoped>
  
  .echarts-wrap{
    width: 100%;
    height: calc(100% - 30px);
    background-color: #012422;
  }
</style>



// WEBPACK FOOTER //
// src/pages/pollute/charts/yieldPrediction.vue